<his-plam class="noPlamStyle">
	<div [hisDdKey]="hisDdKey" #dDValue>
		<res-organizations-panel #content
            [hisDdKey]="hisDdKey"
            [ngModel]="{ internalOrganizations: this.internalOrganisations, externalOrganizations: this.externalOrganisations }"
			[dynamicComponent]="dynamicComponent"
		    [hisDynamicContent]="hisDdKey" 
			[showCreateLink]="true"
			[editMode]="true"
			[singleSelect]="singleSelect"
			[header]="dDValue.ddLabeltext"
			[ddKey]="dDValue.ddIdentifier"
			[noAssignedMessage]="noAssignedMessage"
			[assignLink]="assignLink" 
			(internalOrganizationsChange)="selectedInternalOrgUnitChange($event)"
			(deleteInternalOrganizationChange)="deleteOrganizationChange($event)"
			(externalOrganizationsChange)="selectedExternalOrgUnitChange($event)"
			(deleteExternalOrganizationChange)="deleteOrganizationChange($event)">
		</res-organizations-panel>
	</div>
</his-plam>
